import { CSSProperties } from 'react'

export type Icons =
  | 'arrow-right'
  | 'arrow-left'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-right'
  | 'chevron-up'
  | 'filled-chevron-right'
  | 'filled-chevron-left'
  | 'cart'
  | 'account'
  | 'mobile-menu'
  | 'world'
  | 'search'
  | 'minus'
  | 'plus'
  | 'headset'
  | 'cross'
  | 'swipe-right'
  | 'swipe-left'
  | 'download'
  | 'list'
  | 'filter'
  | 'video'
  | 'checkmark'
  | 'location'
  | 'calender'
  | 'information'
  | 'clock'
  | 'export'

export type Props = {
  name: Icons
  className?: string
  viewBox?: string
  size?: number
  style?: CSSProperties
}

export const Icon = ({ name, className = '', viewBox, size, style }: Props) => {
  const selectIcon = () => {
    switch (name) {
      case 'arrow-right':
        return {
          width: 14,
          height: 12,
          icon: (
            <>
              <title>Arrow Right</title>
              <desc>An arrow pointing right</desc>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.3993 6.48728L9.06889 10.8351C8.92976 10.9742 8.75584 11.0438 8.58193 11.0438C8.40802 11.0438 8.2341 10.9742 8.09497 10.8351C7.81671 10.5568 7.81671 10.1221 8.09497 9.8438L11.2428 6.69597H1.08628C0.703668 6.69597 0.390625 6.38293 0.390625 6.00032C0.390625 5.61771 0.703668 5.30467 1.08628 5.30467H11.2428L8.07758 2.13945C7.79932 1.86119 7.79932 1.42641 8.07758 1.14815C8.35584 0.869888 8.79063 0.869888 9.06889 1.14815L13.3993 5.49597C13.6776 5.77423 13.6776 6.22641 13.3993 6.48728Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'arrow-left':
        return {
          width: 24,
          height: 24,
          icon: (
            <>
              <title>Arrow Reft</title>
              <desc>An arrow pointing left</desc>
              <path
                d="M21.913 12C21.913 12.5739 21.4434 13.0435 20.8695 13.0435H5.63474L10.3565 17.7913C10.7739 18.2087 10.7739 18.8609 10.3565 19.2783C10.1739 19.4609 9.913 19.5652 9.62605 19.5652C9.36518 19.5652 9.07822 19.4609 8.89561 19.2522L2.39996 12.7304C1.98257 12.313 1.98257 11.6609 2.39996 11.2696L8.89561 4.74783C9.313 4.33044 9.96518 4.33044 10.3826 4.74783C10.8 5.16522 10.8 5.81739 10.3826 6.23478L5.63474 10.9565H20.8695C21.4434 10.9565 21.913 11.4261 21.913 12Z"
                fill="#333333"
              />
            </>
          ),
        }
      case 'chevron-down':
        return {
          width: 14,
          height: 8,
          icon: (
            <>
              <title>Chevron Down</title>
              <desc>A chevron pointing down</desc>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.2137 1.92C13.6241 1.49009 13.6241 0.821343 13.2137 0.391434C12.7791 -0.0145924 12.1031 -0.0145924 11.6685 0.391434L7.03296 5.04879L2.34914 0.415317C1.91456 -0.0145923 1.23854 -0.0145923 0.803963 0.415317C0.369382 0.845227 0.369382 1.51398 0.803963 1.94389L6.28452 7.34164C6.47767 7.53271 6.76739 7.65213 7.05711 7.65213C7.34683 7.65213 7.61241 7.53271 7.8297 7.34164L13.2137 1.92Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'chevron-left':
        return {
          width: 10,
          height: 16,
          icon: (
            <>
              <title>Chevron Left</title>
              <desc>A chevron pointing left</desc>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.564594 8.0002C0.564594 8.28715 0.668942 8.54802 0.877638 8.75672L7.66025 15.2785C7.86894 15.4611 8.12981 15.5654 8.39068 15.5654C8.67764 15.5654 8.93851 15.4611 9.1472 15.2524C9.53851 14.835 9.53851 14.1828 9.12112 13.7654L3.12112 8.0002L9.12112 2.23498C9.53851 1.84368 9.53851 1.16542 9.1472 0.748024C8.7559 0.330633 8.07764 0.330633 7.66025 0.721937L0.877638 7.24367C0.668942 7.45237 0.564594 7.71324 0.564594 8.0002Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'chevron-right':
        return {
          width: 10,
          height: 16,
          icon: (
            <>
              <title>Chevron Right</title>
              <desc>A chevron pointing right</desc>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.43541 8.0002C9.43541 8.28715 9.33106 8.54802 9.12236 8.75672L2.33975 15.2785C2.13106 15.4611 1.87019 15.5654 1.60932 15.5654C1.32236 15.5654 1.06149 15.4611 0.852796 15.2524C0.461492 14.835 0.461492 14.1828 0.878883 13.7654L6.87888 8.0002L0.878883 2.23498C0.461492 1.84368 0.461492 1.16542 0.852796 0.748024C1.2441 0.330633 1.92236 0.330633 2.33975 0.721937L9.12236 7.24367C9.33106 7.45237 9.43541 7.71324 9.43541 8.0002Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'chevron-up':
        return {
          width: 14,
          height: 8,
          icon: (
            <>
              <title>Chevron Up</title>
              <desc>A chevron pointing up</desc>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.70164 0.658147C7.50885 0.467226 7.21967 0.3479 6.93048 0.3479C6.6413 0.3479 6.37621 0.467226 6.15932 0.658147L0.785287 6.07551C0.375607 6.50508 0.375607 7.1733 0.785287 7.60287C1.21907 8.00858 1.89383 8.00858 2.32761 7.60287L6.95458 2.94919L11.6538 7.60287C11.8707 7.81766 12.1358 7.91312 12.425 7.91312C12.7142 7.91312 12.9793 7.81766 13.1962 7.60287C13.63 7.1733 13.63 6.50508 13.1962 6.07551L7.70164 0.658147Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'filled-chevron-right':
        return {
          width: 15,
          height: 18,
          icon: (
            <>
              <title>Filled Chevron Right</title>
              <desc>A filled chevron pointing right</desc>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 9L-8.15666e-07 17.6603L-5.85621e-08 0.339745L15 9Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'filled-chevron-left':
        return {
          width: 15,
          height: 18,
          icon: (
            <>
              <title>Filled Chevron Left</title>
              <desc>A filled chevron pointing left</desc>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.37114e-07 9L15 17.6603L15 0.339745L4.37114e-07 9Z"
                fill="currentColor"
              />
            </>
          ),
        }

      case 'cart':
        return {
          width: 30,
          height: 30,
          icon: (
            <>
              <g clipPath="url(#clip0)">
                <path
                  d="M29.419 9.14607L26.0695 19.6956C25.819 20.4469 25.1616 20.9478 24.379 20.9478H11.4503C10.699 20.9478 9.97903 20.4782 9.7286 19.7895L4.78251 6.5478H1.93381C1.24512 6.5478 0.681641 5.98433 0.681641 5.29563C0.681641 4.60694 1.24512 4.04346 1.93381 4.04346H5.65903C6.19121 4.04346 6.66077 4.3878 6.8486 4.88867L11.9512 18.4435H23.8469L26.5077 9.99128H11.7634C11.0747 9.99128 10.5112 9.4278 10.5112 8.73911C10.5112 8.05041 11.0747 7.48694 11.7634 7.48694H28.2295C28.6364 7.48694 29.0121 7.70607 29.2312 8.01911C29.4816 8.33215 29.5443 8.77041 29.419 9.14607ZM12.0764 22.6069C11.5442 22.6069 11.0121 22.8261 10.6364 23.2017C10.2608 23.5774 10.0416 24.1095 10.0416 24.6417C10.0416 25.1739 10.2608 25.7061 10.6364 26.0817C11.0121 26.4574 11.5442 26.6765 12.0764 26.6765C12.6086 26.6765 13.1408 26.4574 13.5164 26.0817C13.8921 25.7061 14.1112 25.1739 14.1112 24.6417C14.1112 24.1095 13.8921 23.5774 13.5164 23.2017C13.1408 22.8261 12.6086 22.6069 12.0764 22.6069ZM23.3147 22.6069C22.7825 22.6069 22.2503 22.8261 21.8747 23.2017C21.499 23.5774 21.2799 24.1095 21.2799 24.6417C21.2799 25.1739 21.499 25.7061 21.8747 26.0817C22.2503 26.4574 22.7825 26.6765 23.3147 26.6765C23.8469 26.6765 24.379 26.4574 24.7547 26.0817C25.1303 25.7061 25.3495 25.1739 25.3495 24.6417C25.3495 24.1095 25.1303 23.5774 24.7547 23.2017C24.379 22.8261 23.8469 22.6069 23.3147 22.6069Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="28.8"
                    height="28.8"
                    fill="white"
                    transform="translate(0.681641 0.599976)"
                  />
                </clipPath>
              </defs>
            </>
          ),
        }
      case 'account':
        return {
          width: 24,
          height: 24,
          icon: (
            <>
              <path
                d="M12 14.8956C15.8609 14.8956 19.0174 11.7391 19.0174 7.85216C19.0174 3.93911 15.8609 0.782593 12 0.782593C8.13913 0.782593 4.98261 3.93911 4.98261 7.82607C4.98261 11.7391 8.13913 14.8956 12 14.8956ZM12 2.86955C14.713 2.86955 16.9304 5.08694 16.9304 7.82607C16.9304 10.5652 14.713 12.7826 12 12.7826C9.28696 12.7826 7.06957 10.5652 7.06957 7.82607C7.06957 5.08694 9.28696 2.86955 12 2.86955ZM15.2609 15.5739C14.9217 15.4695 14.5304 15.5478 14.2696 15.7826L12 17.713L9.73043 15.7826C9.44348 15.5478 9.07826 15.4695 8.73913 15.5739C7.27826 16.0435 0 18.5478 0 22.1739C0 22.7478 0.469565 23.2174 1.04348 23.2174H22.9565C23.5304 23.2174 24 22.7478 24 22.1739C24 18.5478 16.7217 16.0435 15.2609 15.5739ZM2.63478 21.1304C3.78261 19.9043 6.54783 18.5478 8.84348 17.7652L11.3217 19.8782C11.713 20.2174 12.287 20.2174 12.6783 19.8782L15.1565 17.7652C17.4522 18.5739 20.2174 19.9304 21.3652 21.1304H2.63478Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'mobile-menu':
        return {
          width: 14,
          height: 11,
          icon: (
            // remove rect elements and comment in paths when search is implemented
            <>
              {/* <path
                d="M12.5961 3.91302C8.50696 3.91302 5.18304 7.28476 5.18304 11.3978C5.18304 13.1435 5.78087 14.7217 6.7613 16.013L2.45699 20.413C2.05047 20.8434 2.05047 21.513 2.45699 21.9195C2.67221 22.1347 2.93525 22.2304 3.1983 22.2304C3.48525 22.2304 3.7483 22.1347 3.96351 21.9195L8.26783 17.5195C9.48739 18.4043 10.97 18.9065 12.5722 18.9065C16.6613 18.9065 19.9852 15.5348 19.9852 11.4217C19.9852 7.30868 16.6852 3.91302 12.5961 3.91302ZM12.5961 17.0174C9.55913 17.0174 7.09609 14.5065 7.09609 11.4217C7.09609 8.33694 9.55913 5.82607 12.5961 5.82607C15.633 5.82607 18.0961 8.33694 18.0961 11.4217C18.0961 14.5065 15.633 17.0174 12.5961 17.0174Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.266 2.19718H26.7335C27.4348 2.19718 27.9998 1.70704 27.9998 1.09859C27.9998 0.490141 27.4348 0 26.7335 0H14.266C13.5647 0 12.9998 0.490141 12.9998 1.09859C12.9998 1.70704 13.5647 2.19718 14.266 2.19718ZM26.7335 4.90141C27.4348 4.90141 27.9998 5.39155 27.9998 6C27.9998 6.60845 27.4348 7.09859 26.7335 7.09859H19.7729C19.2646 6.26036 18.6154 5.51703 17.8582 4.90141H26.7335ZM20.9853 12H26.7335C27.4348 12 27.9998 11.5099 27.9998 10.9014C27.9998 10.293 27.4348 9.80282 26.7335 9.80282H20.8303C20.9414 10.3512 20.9998 10.9188 20.9998 11.5C20.9998 11.6678 20.9949 11.8346 20.9853 12Z"
                fill="currentColor"
              /> */}
              <rect width="14" height="1.5" rx="0.75" fill="#3C3C3B" />
              <rect y="4.5" width="14" height="1.5" rx="0.75" fill="#3C3C3B" />
              <rect y="9" width="14" height="1.5" rx="0.75" fill="#3C3C3B" />
            </>
          ),
        }
      case 'minus':
        return {
          width: 14,
          height: 4,
          icon: (
            <>
              <title>Minus</title>
              <desc>A minus</desc>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.7391 3.174H1.26083C0.608653 3.174 0.0869141 2.65226 0.0869141 2.00009C0.0869141 1.34791 0.608653 0.826172 1.26083 0.826172H12.7391C13.3913 0.826172 13.913 1.34791 13.913 2.00009C13.913 2.65226 13.3913 3.174 12.7391 3.174Z"
                fill="currentColor"
              />
            </>
          ),
        }

      case 'world':
        return {
          width: 30,
          height: 30,
          icon: (
            <>
              <g clipPath="url(#clip0)">
                <path
                  d="M15.0816 0.599976C7.13034 0.599976 0.681641 7.04867 0.681641 15C0.681641 22.9513 7.13034 29.4 15.0816 29.4C23.0329 29.4 29.4816 22.9513 29.4816 15C29.4816 7.04867 23.0329 0.599976 15.0816 0.599976ZM16.2399 26.833C16.1773 26.833 16.1147 26.833 16.0208 26.8643V20.0713C17.6486 20.04 19.1199 20.0087 20.466 19.9148C19.2764 23.5774 17.0538 26.0191 16.2399 26.833ZM13.9234 26.833C13.0782 25.9878 10.8869 23.5461 9.69729 19.9148C11.0121 20.0087 12.5147 20.0713 14.1425 20.0713V26.8643C14.0799 26.8643 14.0173 26.833 13.9234 26.833ZM3.18599 15C3.18599 14.2174 3.2799 13.4348 3.40512 12.6835C4.09381 12.5582 5.4086 12.3704 7.25555 12.1826C7.09903 13.0904 7.00512 14.0295 7.00512 15.0313C7.00512 16.033 7.09903 16.9721 7.22425 17.8487C5.4086 17.6608 4.06251 17.473 3.37381 17.3478C3.2799 16.5652 3.18599 15.7826 3.18599 15ZM8.91468 15C8.91468 13.9356 9.0399 12.9339 9.22773 11.9948C10.6677 11.9008 12.2956 11.8069 14.1425 11.8069V18.193C12.3269 18.1617 10.6677 18.0991 9.19642 17.9739C9.0399 17.0661 8.91468 16.0643 8.91468 15ZM16.2086 3.16693C17.0538 4.01215 19.2138 6.5165 20.4347 10.0852C19.1199 9.99128 17.6486 9.92867 16.0208 9.92867V3.13563C16.0834 3.13563 16.146 3.16693 16.2086 3.16693ZM14.1425 3.13563V9.92867C12.5147 9.95998 11.0434 9.99128 9.7286 10.0852C10.9182 6.5165 13.1095 4.01215 13.9234 3.16693C14.0173 3.16693 14.0799 3.13563 14.1425 3.13563ZM16.0208 18.193V11.8069C17.8364 11.8382 19.4956 11.9008 20.9356 11.9948C21.1234 12.9339 21.2486 13.9356 21.2486 15C21.2486 16.0643 21.1547 17.0661 20.9669 18.0052C19.5269 18.0991 17.8677 18.1617 16.0208 18.193ZM22.8764 12.1826C24.7234 12.3704 26.0382 12.5582 26.7269 12.6835C26.8834 13.4348 26.9773 14.2174 26.9773 15C26.9773 15.7826 26.8834 16.5652 26.7582 17.3165C26.0695 17.4417 24.7547 17.6295 22.9077 17.8174C23.0642 16.9095 23.1269 15.9704 23.1269 14.9687C23.1269 14.0295 23.0329 13.0591 22.8764 12.1826ZM26.1634 10.68C25.2869 10.5548 24.0347 10.3982 22.4382 10.2417C21.6869 7.54954 20.3721 5.38954 19.2764 3.85563C22.4382 5.04519 24.9425 7.54954 26.1634 10.68ZM10.8869 3.85563C9.7599 5.35824 8.47642 7.51824 7.72512 10.2104C6.1599 10.3356 4.90773 10.5235 3.9999 10.6487C5.22077 7.54954 7.75642 5.04519 10.8869 3.85563ZM3.9999 19.32C4.87642 19.4452 6.1286 19.6017 7.69381 19.7582C8.44512 22.4504 9.69729 24.6104 10.8242 26.113C7.69381 24.8921 5.22077 22.4191 3.9999 19.32ZM19.339 26.113C20.466 24.6104 21.7182 22.4817 22.4695 19.7895C24.0347 19.6643 25.2869 19.4765 26.1634 19.3513C24.9425 22.4191 22.4695 24.8921 19.339 26.113Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="28.8"
                    height="28.8"
                    fill="white"
                    transform="translate(0.681641 0.599976)"
                  />
                </clipPath>
              </defs>
            </>
          ),
        }
      case 'search':
        return {
          width: 30,
          height: 30,
          icon: (
            <>
              <path
                d="M17.1712 3.10425C11.8181 3.10425 7.4668 7.51816 7.4668 12.9025C7.4668 15.1877 8.24941 17.2538 9.53289 18.9442L3.89815 24.7042C3.36598 25.2677 3.36598 26.1442 3.89815 26.6764C4.17989 26.9581 4.52424 27.0833 4.86859 27.0833C5.24424 27.0833 5.58859 26.9581 5.87033 26.6764L11.5051 20.9164C13.1016 22.0747 15.0425 22.7321 17.1398 22.7321C22.4929 22.7321 26.8442 18.3182 26.8442 12.9338C26.8442 7.54946 22.5242 3.10425 17.1712 3.10425ZM17.1712 20.259C13.1955 20.259 9.97115 16.9721 9.97115 12.9338C9.97115 8.89555 13.1955 5.6086 17.1712 5.6086C21.1468 5.6086 24.3711 8.89555 24.3711 12.9338C24.3711 16.9721 21.1468 20.259 17.1712 20.259Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'plus':
        return {
          width: 14,
          height: 14,
          icon: (
            <>
              <title>Plus</title>
              <desc>A plus</desc>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.913 7.13039C13.913 7.78257 13.3913 8.30431 12.7391 8.30431H8.04344V12.7391C8.04344 13.3913 7.5217 13.913 6.86952 13.913C6.21735 13.913 5.69561 13.3913 5.69561 12.7391V8.30431H1.26083C0.608653 8.30431 0.0869141 7.78257 0.0869141 7.13039C0.0869141 6.47822 0.608653 5.95648 1.26083 5.95648H5.69561V1.26083C5.69561 0.608653 6.21735 0.0869141 6.86952 0.0869141C7.5217 0.0869141 8.04344 0.608653 8.04344 1.26083V5.95648H12.7391C13.3913 5.95648 13.913 6.47822 13.913 7.13039Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'headset':
        return {
          width: 30,
          height: 34,
          icon: (
            <>
              <path
                d="M29.957 14.887L29.9222 23.687C29.9222 24.4522 29.2961 25.0435 28.5309 25.0435C27.7657 25.0435 27.1396 24.4522 27.1396 23.687L27.1744 14.887C27.1744 11.6522 25.9222 8.62609 23.6266 6.33044C21.3309 4.06957 18.3048 2.78261 15.0352 2.78261H15.0005C8.32221 2.78261 2.86134 8.17391 2.82655 14.8174V23.6522C2.82655 24.4174 2.20047 25.0435 1.43525 25.0435C0.670032 25.0435 0.0439453 24.4174 0.0439453 23.6522L0.0787279 14.8174C0.0787279 6.64348 6.79177 0 15.0005 0H15.0352C19.0352 0 22.7918 1.56522 25.5744 4.38261C28.4266 7.2 29.957 10.9217 29.957 14.887ZM11.7309 15.6174C11.9744 15.8609 12.0787 16.1043 12.0787 16.4174L12.0439 30.5043C12.0439 31.1652 11.4874 31.6522 10.8266 31.6522C6.23525 31.6522 4.7396 29.0087 4.56568 27.5478C4.56568 27.513 4.56568 27.5478 4.56568 27.4783V19.5478C4.56568 19.513 4.56568 19.4783 4.56568 19.4087C4.7396 17.9826 6.27003 15.3043 10.8266 15.3043H10.8613C11.1744 15.3043 11.4874 15.3739 11.7309 15.6174ZM9.64395 17.7739C7.45264 18.1217 7.07003 19.4087 7.00047 19.6522L6.96568 27.4087C7.03525 27.687 7.41786 28.9391 9.60916 29.287L9.64395 17.7739ZM25.47 19.5478L25.5048 27.4435C25.5048 27.4783 25.5048 27.513 25.5048 27.5478C25.3309 28.9739 23.8353 31.6522 19.2439 31.6522C18.5831 31.6522 18.0266 31.2 18.0266 30.5043L17.9918 16.487C17.9918 16.1739 18.1309 15.8609 18.3396 15.6522C18.5831 15.4087 18.8613 15.3043 19.2092 15.3043H19.2439C23.8005 15.3043 25.3309 17.9826 25.5048 19.4435C25.47 19.4783 25.47 19.4783 25.47 19.5478ZM23.07 27.4087L23.0352 19.6522C22.9657 19.3739 22.5831 18.1217 20.3918 17.7739L20.4266 29.287C22.6526 28.9043 23.0005 27.6522 23.07 27.4087Z"
                fill="currentColor"
              />
            </>
          ),
        }
      case 'cross':
        return {
          width: 24,
          height: 24,
          icon: (
            <path
              d="M18.4435 16.7739C18.913 17.2435 18.913 17.9739 18.4435 18.4435C18.2087 18.6783 17.9217 18.7826 17.6087 18.7826C17.2956 18.7826 17.0087 18.6783 16.7739 18.4435L12 13.6696L7.22609 18.4435C6.9913 18.6783 6.70435 18.7826 6.3913 18.7826C6.07826 18.7826 5.7913 18.6783 5.55652 18.4435C5.08695 17.9739 5.08695 17.2435 5.55652 16.7739L10.3304 12L5.55652 7.22609C5.08695 6.75652 5.08695 6.02608 5.55652 5.55652C6.02608 5.08695 6.75652 5.08695 7.22609 5.55652L12 10.3304L16.7739 5.55652C17.2435 5.08695 17.9739 5.08695 18.4435 5.55652C18.913 6.02608 18.913 6.75652 18.4435 7.22609L13.6696 12L18.4435 16.7739Z"
              fill="currentColor"
            />
          ),
        }
      case 'swipe-right':
        return {
          width: 24,
          height: 24,
          icon: (
            <>
              <path
                d="M4.65817 13.2794L10.9468 6.99074L4.65817 13.2794ZM4.65817 13.2794L4.65883 12.6141V12.614C4.65883 11.5135 4.2127 10.5166 3.49145 9.79536C2.97014 9.27405 2.30451 8.89916 1.56033 8.72929C1.49762 8.71244 1.43353 8.70725 1.37268 8.70724M4.65817 13.2794L10.9469 6.99068C11.7467 6.1899 13.0561 6.19001 13.8568 6.99068C14.6576 7.79049 14.6575 9.09995 13.8568 9.90062L11.0713 12.6861C11.5564 12.7106 12.0348 12.9033 12.4071 13.2756C12.721 13.5895 12.9079 13.9816 12.9755 14.3872L14.2139 19.0281L14.214 19.0284C14.3949 19.7129 14.2204 20.4716 13.6848 21.0072L11.4368 23.2552C8.94377 25.7482 4.90408 25.7482 2.41107 23.2553C1.26938 22.1145 0.655511 20.6477 0.560965 19.1553L0.542969 19.1707V18.8989V18.7472V18.7472V18.7472V18.7472V18.7471V18.7471V18.7471V18.7471V18.7471V18.7471V18.747V18.747V18.747V18.747V18.747V18.747V18.7469V18.7469V18.7469V18.7469V18.7469V18.7469V18.7468V18.7468V18.7468V18.7468V18.7468V18.7467V18.7467V18.7467V18.7467V18.7467V18.7467V18.7466V18.7466V18.7466V18.7466V18.7466V18.7466V18.7465V18.7465V18.7465V18.7465V18.7465V18.7465V18.7464V18.7464V18.7464V18.7464V18.7464V18.7464V18.7463V18.7463V18.7463V18.7463V18.7463V18.7463V18.7462V18.7462V18.7462V18.7462V18.7462V18.7462V18.7461V18.7461V18.7461V18.7461V18.7461V18.7461V18.746V18.746V18.746V18.746V18.746V18.746V18.7459V18.7459V18.7459V18.7459V18.7459V18.7459V18.7458V18.7458V18.7458V18.7458V18.7458V18.7458V18.7457V18.7457V18.7457V18.7457V18.7457V18.7457V18.7456V18.7456V18.7456V18.7456V18.7456V18.7456V18.7455V18.7455V18.7455V18.7455V18.7455V18.7455V18.7454V18.7454V18.7454V18.7454V18.7454V18.7454V18.7453V18.7453V18.7453V18.7453V18.7453V18.7453V18.7452V18.7452V18.7452V18.7452V18.7452V18.7452V18.7451V18.7451V18.7451V18.7451V18.7451V18.7451V18.745V18.745V18.745V18.745V18.745V18.745V18.7449V18.7449V18.7449V18.7449V18.7449V18.7449V18.7449V18.7448V18.7448V18.7448V18.7448V18.7448V18.7448V18.7447V18.7447V18.7447V18.7447V18.7447V18.7447V18.7446V18.7446V18.7446V18.7446V18.7446V18.7446V18.7445V18.7445V18.7445V18.7445V18.7445V18.7445V18.7445V18.7444V18.7444V18.7444V18.7444V18.7444V18.7444V18.7443V18.7443V18.7443V18.7443V18.7443V18.7443V18.7442V18.7442V18.7442V18.7442V18.7442V18.7442V18.7442V18.7441V18.7441V18.7441V18.7441V18.7441V18.7441V18.744V18.744V18.744V18.744V18.744V18.744V18.744V18.7439V18.7439V18.7439V18.7439V18.7439V18.7439V18.7438V18.7438V18.7438V18.7438V18.7438V18.7438V18.7438V18.7437V18.7437V18.7437V18.7437V18.7437V18.7437V18.7437V18.7436V18.7436V18.7436V18.7436V18.7436V18.7436V18.7435V18.7435V18.7435V18.7435V18.7435V18.7435V18.7435V18.7434V18.7434V18.7434V18.7434V18.7434V18.7434V18.7434V18.7433V18.7433V18.7433V18.7433V18.7433V18.7433V18.7433V18.7432V18.7432V18.7432V18.7432V18.7432V18.7432V18.7432V18.7431V18.7431V18.7431V18.7431V18.7431V18.7431V18.7431V18.743V18.743V18.743V18.743V18.743V18.743V18.743V18.7429V18.7429V18.7429V18.7429V18.7429V18.7429V18.7429V18.7428V18.7428V18.7428V18.7428V18.7428V18.7428V18.7428V18.7428V18.7427V18.7427V18.7427V18.7427V18.7427V18.7427V18.7427V18.7426V18.7426V18.7426V18.7426V18.7426V18.7426V18.7426V18.7426V18.7425V18.7425V18.7425V18.7425V18.7425V18.7425V18.7425V18.7424V18.7424V18.7424V18.7424V18.7424V18.7424V18.7424V18.7424V18.7423V18.7423V18.7423V18.7423V18.7423V18.7423V18.7423V18.7423V18.7422V18.7422V18.7422V18.7422V18.7422V18.7422V18.7422V18.7422V18.7421V18.7421V18.7421V18.7421V18.7421V18.7421V18.7421V18.7421V18.742V18.742V18.742V18.742V18.742V18.742V18.742V18.742V18.7419V18.7419V18.7419V18.7419V18.7419V18.7419V18.7419V18.7419V18.7419V18.7418V18.7418V18.7418V18.7418V18.7418V18.7418V18.7418V18.7418V18.7418V18.7417V18.7417V18.7417V18.7417V18.7417V18.7417V18.7417V18.7417V18.7416V18.7416V18.7416V18.7416V18.7416V18.7416V18.7416V18.7416V18.7416V18.7416V18.7415V18.7415V18.7415V18.7415V18.7415V18.7415V18.7415V18.7415V18.7415V18.7414V18.7414V18.7414V18.7414V18.7414V18.7414V18.7414V18.7414V18.7414V18.7414V18.7413V18.7413V18.7413V18.7413V18.7413V18.7413V18.7413V18.7413V18.7413V18.7413V18.7412V18.7412V18.7412V18.7412V18.7412V18.7412V18.7412V18.7412V18.7412V18.7412V18.7411V18.7411V18.7411V18.7411V18.7411V18.7411V18.7411V18.7411V18.7411V18.7411V18.7411V18.741V18.741V18.741V18.741V18.741V18.741V18.741V18.741V18.741V18.741V18.741V18.7409V18.7409V18.7409V18.7409V18.7409V18.7409V18.7409V18.7409V18.7409V18.7409V18.7409V18.7409V18.7408V18.7408V18.7408V18.7408V18.7408V18.7408V18.7408V18.7408V18.7408V18.7408V18.7408V18.7408V18.7408V18.7407V18.7407V18.7407V18.7407V18.7407V18.7407V18.7407V18.7407V18.7407V18.7407V18.7406V18.7406V18.7406V18.7406V18.7406V18.7406V18.7406V18.7406V18.7405V18.7405V18.7405V18.7405V18.7405V18.7405V18.7405V18.7405V18.7404L0.543935 9.53582C0.543935 9.53582 0.543935 9.53582 0.543935 9.53581C0.543942 9.07752 0.914784 8.70618 1.37268 8.70724M1.37268 8.70724C1.37273 8.70724 1.37278 8.70724 1.37283 8.70724L1.37252 8.83224V8.70724C1.37257 8.70724 1.37263 8.70724 1.37268 8.70724ZM3.27209 22.3942L3.27207 22.3942C2.33363 21.4558 1.79865 20.2035 1.7662 18.8684L1.76052 10.0656C2.08341 10.2038 2.37875 10.4039 2.63028 10.6563L2.63042 10.6564C3.15406 11.18 3.44232 11.874 3.4414 12.6148V12.615V14.401C3.4414 14.616 3.56752 14.8127 3.76463 14.9007C4.1631 15.0792 4.64543 15.0113 4.97498 14.6817L11.8069 7.84978C12.1351 7.52161 12.6696 7.52178 12.9966 7.84967L12.9967 7.84978C13.3249 8.17795 13.3247 8.71242 12.9968 9.03947L12.9967 9.03959L9.03132 13.005C8.85007 13.1862 8.80132 13.4635 8.91215 13.6961C9.0228 13.9284 9.26722 14.0658 9.5226 14.0402L9.52271 14.0402L10.8728 13.9039C11.0277 13.8884 11.3122 13.8998 11.548 14.1357C11.6995 14.2872 11.7564 14.4665 11.7769 14.5914L11.7763 14.5915L11.7794 14.6031L13.0339 19.3407L13.0339 19.3407C13.1127 19.6383 13.0328 19.9381 12.8247 20.1462L10.5767 22.3942C8.5621 24.4088 5.28569 24.4088 3.27209 22.3942Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="0.25"
              />
              <path
                d="M6.53743 0.911612L6.44904 0.823223L6.36065 0.911612L5.67736 1.5949L5.58897 1.68329L5.67736 1.77168L7.21327 3.30759H2.59961H2.47461V3.43259V4.39906V4.52406H2.59961H7.21339L5.6812 6.0571L5.59286 6.14549L5.68123 6.23385L6.36452 6.91714L6.45292 7.00555L6.54131 6.91713L9.45327 4.0042L9.54163 3.91581L9.45325 3.82744L6.53743 0.911612Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="0.25"
              />
            </>
          ),
        }
      case 'download':
        return {
          height: 31,
          width: 32,
          icon: (
            <>
              <g clipPath="url(#clip0)">
                <path
                  d="M24.413 18.004V23.3257C24.413 23.8736 23.9826 24.304 23.4347 24.304H8.56517C8.01735 24.304 7.58691 23.8736 7.58691 23.3257V18.004C7.58691 17.4562 8.01735 17.0257 8.56517 17.0257C9.113 17.0257 9.54344 17.4562 9.54344 18.004V22.3475H22.4565V18.004C22.4565 17.4562 22.8869 17.0257 23.4347 17.0257C23.9826 17.0257 24.413 17.4562 24.413 18.004ZM15.2956 19.2171C15.4717 19.4127 15.726 19.5105 16 19.5105C16.2739 19.5105 16.5087 19.4127 16.7043 19.2171L20.5978 15.2257C20.9695 14.8344 20.9695 14.2279 20.5782 13.8366C20.1869 13.4649 19.5804 13.4649 19.1891 13.8562L16.9782 16.1453V7.67357C16.9782 7.12575 16.5478 6.69531 16 6.69531C15.4521 6.69531 15.0217 7.12575 15.0217 7.67357V16.1453L12.7913 13.8757C12.4195 13.4844 11.7934 13.4844 11.4021 13.8562C11.0108 14.2279 11.0108 14.854 11.3826 15.2453L15.2956 19.2171Z"
                  fill="currentColor"
                />
              </g>
              <rect
                x="0.75"
                y="0.75"
                width="30.5"
                height="29.5"
                rx="14.75"
                stroke="currentColor"
                strokeWidth="1.5"
              />
              <defs>
                <clipPath id="clip0">
                  <rect width="18" height="18" fill="white" transform="translate(7 6.5)" />
                </clipPath>
              </defs>
            </>
          ),
        }
      case 'list':
        return {
          width: 17,
          height: 16,
          icon: (
            <>
              <g clipPath="url(#clip0)">
                <path
                  d="M6.7954 2.43477C6.7954 1.94782 7.17801 1.56521 7.66496 1.56521H15.2824C15.7693 1.56521 16.1519 1.94782 16.1519 2.43477C16.1519 2.92173 15.7693 3.30434 15.2824 3.30434H7.66496C7.1954 3.30434 6.7954 2.92173 6.7954 2.43477ZM15.2824 7.13042H7.66496C7.17801 7.13042 6.7954 7.51303 6.7954 7.99999C6.7954 8.48695 7.17801 8.86955 7.66496 8.86955H15.2824C15.7693 8.86955 16.1519 8.48695 16.1519 7.99999C16.1519 7.51303 15.7693 7.13042 15.2824 7.13042ZM15.2824 12.6956H7.66496C7.17801 12.6956 6.7954 13.0783 6.7954 13.5652C6.7954 14.0522 7.17801 14.4348 7.66496 14.4348H15.2824C15.7693 14.4348 16.1519 14.0522 16.1519 13.5652C16.1519 13.0783 15.7693 12.6956 15.2824 12.6956ZM4.84757 1.13042C4.84757 0.799989 4.56931 0.521729 4.23888 0.521729H1.63018C1.29975 0.521729 1.02148 0.799989 1.02148 1.13042V3.73912C1.02148 4.06955 1.29975 4.34782 1.63018 4.34782H4.23888C4.56931 4.34782 4.84757 4.06955 4.84757 3.73912V1.13042ZM4.84757 9.30434C4.84757 9.63477 4.56931 9.91303 4.23888 9.91303H1.63018C1.29975 9.91303 1.02148 9.63477 1.02148 9.30434V6.69564C1.02148 6.36521 1.29975 6.08695 1.63018 6.08695H4.23888C4.56931 6.08695 4.84757 6.36521 4.84757 6.69564V9.30434ZM3.80409 7.30434H2.23888V8.69564H3.80409V7.30434ZM4.84757 14.8696C4.84757 15.2 4.56931 15.4783 4.23888 15.4783H1.63018C1.29975 15.4783 1.02148 15.2 1.02148 14.8696V12.2609C1.02148 11.9304 1.29975 11.6522 1.63018 11.6522H4.23888C4.56931 11.6522 4.84757 11.9304 4.84757 12.2609V14.8696ZM3.80409 12.8696H2.23888V14.4348H3.80409V12.8696Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="16" height="16" fill="white" transform="translate(0.5)" />
                </clipPath>
              </defs>
            </>
          ),
        }
      case 'filter':
        return {
          width: 17,
          height: 16,
          icon: (
            <>
              <g clipPath="url(#clip0)">
                <path
                  d="M16.0831 0.712996C15.9613 0.486909 15.7179 0.347778 15.4744 0.347778H1.52654C1.28307 0.347778 1.03959 0.486909 0.917848 0.712996C0.796109 0.939083 0.848283 1.21734 0.987414 1.42604L6.4135 9.39126V14.6608C6.4135 15.2 6.77872 15.6521 7.33524 15.6521H9.66568C10.2048 15.6521 10.5874 15.2173 10.5874 14.6608V9.39126L16.0135 1.42604C16.1526 1.21734 16.2048 0.939083 16.0831 0.712996ZM9.35263 8.79995C9.26568 8.9043 9.19611 9.04343 9.19611 9.18256V14.2608H7.80481V9.18256C7.80481 9.04343 7.73524 8.9043 7.64828 8.79995L5.99611 6.38256C6.34394 6.27821 6.76133 6.17387 7.2135 6.19126C7.75263 6.19126 8.11785 6.2956 8.51785 6.39995C8.93524 6.5043 9.35263 6.60865 9.94394 6.62604C10.2918 6.62604 10.6048 6.60865 10.8831 6.57387L9.35263 8.79995ZM11.8918 5.07821C11.8744 5.07821 11.1439 5.40865 9.94394 5.39126C9.50916 5.39126 9.17872 5.3043 8.8135 5.19995C8.39611 5.0956 7.90915 4.97387 7.2135 4.95647C6.43089 4.95647 5.73524 5.14778 5.26568 5.32169L2.84828 1.73908H14.17L11.8918 5.07821ZM10.4657 3.93039C10.3439 3.80865 10.257 3.61734 10.257 3.44343C10.257 3.25213 10.3265 3.07821 10.4657 2.95647C10.5874 2.83473 10.7787 2.74778 10.9526 2.74778C11.1439 2.74778 11.3179 2.81734 11.4396 2.95647C11.5613 3.0956 11.6483 3.26952 11.6483 3.44343C11.6483 3.63473 11.5787 3.80865 11.4396 3.93039C11.3005 4.05213 11.1265 4.13908 10.9526 4.13908C10.7787 4.13908 10.5874 4.05213 10.4657 3.93039Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="16" height="16" fill="white" transform="translate(0.5)" />
                </clipPath>
              </defs>
            </>
          ),
        }
      case 'checkmark':
        return {
          width: 16,
          height: 16,
          icon: (
            <path
              d="M5.98264 12.5219C5.77395 12.5219 5.58264 12.4523 5.42612 12.2958L1.96525 8.83495C1.65221 8.5219 1.65221 8.03495 1.96525 7.7219C2.27829 7.40886 2.76525 7.40886 3.07829 7.7219L6.00003 10.6263L12.9392 3.70451C13.2522 3.39147 13.7392 3.39147 14.0522 3.70451C14.3653 4.01755 14.3653 4.50451 14.0522 4.81755L6.55656 12.2958C6.38264 12.4523 6.19134 12.5219 5.98264 12.5219Z"
              fill="currentColor"
            />
          ),
        }
      case 'video':
        return {
          width: 18,
          height: 18,
          icon: (
            <>
              <path
                d="M15.5304 1.08351C15.5088 1.08477 15.4874 1.08791 15.4664 1.0929L1.0388 4.42208C0.988527 4.43368 0.941237 4.45566 0.899964 4.48661C0.858691 4.51756 0.824347 4.5568 0.799137 4.60181C0.773927 4.64682 0.758409 4.6966 0.753578 4.74797C0.748748 4.79933 0.754713 4.85113 0.771089 4.90006L1.86215 8.17143V16.991C1.86211 17.0396 1.87166 17.0878 1.89025 17.1327C1.90885 17.1777 1.93612 17.2185 1.97052 17.2529C2.00491 17.2873 2.04575 17.3146 2.0907 17.3332C2.13565 17.3518 2.18382 17.3613 2.23246 17.3613H16.6598C16.7084 17.3613 16.7565 17.3517 16.8014 17.3331C16.8463 17.3144 16.8871 17.2872 16.9215 17.2528C16.9558 17.2184 16.9831 17.1776 17.0016 17.1326C17.0202 17.0877 17.0297 17.0396 17.0297 16.991V8.1129C17.0297 8.01479 16.9907 7.9207 16.9213 7.85132C16.852 7.78195 16.7579 7.74297 16.6598 7.74296H5.47999L16.7432 5.14284C16.7933 5.13117 16.8404 5.10921 16.8815 5.07833C16.9226 5.04746 16.9568 5.00836 16.982 4.96352C17.0071 4.91869 17.0226 4.8691 17.0276 4.81793C17.0325 4.76676 17.0267 4.71512 17.0106 4.66631L15.9007 1.33604C15.8751 1.25923 15.825 1.19294 15.7581 1.14732C15.6913 1.1017 15.6112 1.07929 15.5304 1.08351ZM15.3053 1.88916L16.1803 4.51349L13.9263 5.03373L14.4093 3.10414L13.6911 2.92422L13.1174 5.22015L10.6871 5.78121L11.4375 2.78152L15.3053 1.88916ZM10.6278 2.96866L9.87892 5.96763L7.41392 6.53629L8.10396 3.55104L10.6278 2.96866ZM7.30192 3.73602L6.61188 6.72162L4.19131 7.28016L4.91351 4.28697L7.30192 3.73602ZM4.10677 4.47339L3.38494 7.46622L2.47668 7.67576L1.60131 5.05143L4.10677 4.47339ZM2.60241 8.48285H16.2898V16.621H2.60241V8.48285Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="0.25"
              />
              <path
                d="M7.79362 9.96259C7.58509 9.95609 7.41244 10.1232 7.41211 10.3318V14.7726C7.41263 15.0562 7.71883 15.2338 7.96523 15.0935L11.8501 12.873C11.9648 12.807 12.0355 12.6846 12.0354 12.5522C12.0355 12.4198 11.9648 12.2975 11.8501 12.2314L7.96523 10.011C7.91283 9.98111 7.85391 9.96449 7.79362 9.96259ZM8.15237 10.9709L10.9216 12.5522L8.15237 14.1335V10.9709Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="0.25"
              />
            </>
          ),
        }
      case 'location':
        return {
          width: 16,
          height: 16,
          icon: (
            <path
              d="M11.8958 1.37391C10.9045 0.486957 9.51316 0 8.00012 0C6.48707 0 5.09577 0.486957 4.10446 1.37391C2.88707 2.45217 2.26099 4.06957 2.26099 6.08696C2.26099 10.4522 7.28707 15.5826 7.51316 15.7913C7.65229 15.9304 7.8262 16 8.00012 16C8.17403 16 8.36533 15.9304 8.48707 15.7913C8.71316 15.5826 13.7392 10.4522 13.7392 6.08696C13.7392 4.06957 13.1132 2.45217 11.8958 1.37391ZM8.00012 14.2783C7.53055 13.7565 6.78272 12.887 6.05229 11.8435C4.48707 9.61739 3.65229 7.63478 3.65229 6.08696C3.65229 1.73913 6.97403 1.3913 8.00012 1.3913C12.0349 1.3913 12.3479 4.9913 12.3479 6.08696C12.3479 9.14783 9.2349 12.9217 8.00012 14.2783ZM8.00012 3.0087C6.46968 3.0087 5.2349 4.27826 5.2349 5.82609C5.2349 7.37391 6.46968 8.62609 8.00012 8.62609C9.53055 8.62609 10.7653 7.35652 10.7653 5.8087C10.7653 4.26087 9.53055 3.0087 8.00012 3.0087ZM8.00012 7.4087C7.14794 7.4087 6.45229 6.69565 6.45229 5.8087C6.45229 4.92174 7.14794 4.2087 8.00012 4.2087C8.85229 4.2087 9.54794 4.92174 9.54794 5.8087C9.54794 6.69565 8.85229 7.4087 8.00012 7.4087Z"
              fill="currentColor"
            />
          ),
        }
      case 'calender':
        return {
          width: 16,
          height: 16,
          icon: (
            <>
              <g clip-path="url(#clip0_16231_12830)">
                <path
                  d="M3.82609 3.79145V1.56537C3.82609 1.07841 4.2087 0.695801 4.69565 0.695801C5.18261 0.695801 5.56522 1.07841 5.56522 1.56537V3.79145C5.56522 4.27841 5.18261 4.66102 4.69565 4.66102C4.2087 4.66102 3.82609 4.27841 3.82609 3.79145ZM11.3043 4.66102C11.7913 4.66102 12.1739 4.27841 12.1739 3.79145V1.56537C12.1739 1.07841 11.7913 0.695801 11.3043 0.695801C10.8174 0.695801 10.4348 1.07841 10.4348 1.56537V3.79145C10.4348 4.27841 10.8174 4.66102 11.3043 4.66102ZM16 2.67841V14.4349C16 14.8175 15.687 15.1306 15.3043 15.1306H0.695652C0.313043 15.1306 0 14.8175 0 14.4349V2.67841C0 2.2958 0.313043 1.91319 0.695652 1.91319H2.31304C2.69565 1.91319 3.0087 2.22624 3.0087 2.60884C3.0087 2.99145 2.69565 3.3045 2.31304 3.3045H1.3913V6.26102H14.6087V3.3045H13.687C13.3043 3.3045 12.9913 2.99145 12.9913 2.60884C12.9913 2.22624 13.3043 1.91319 13.687 1.91319H15.3043C15.687 1.91319 16 2.2958 16 2.67841ZM14.6087 13.7393V7.47841H1.3913V13.7393H14.6087ZM6.90435 3.3045H9.09565C9.47826 3.3045 9.7913 2.99145 9.7913 2.60884C9.7913 2.22624 9.47826 1.91319 9.09565 1.91319H6.90435C6.52174 1.91319 6.2087 2.22624 6.2087 2.60884C6.2087 2.99145 6.52174 3.3045 6.90435 3.3045Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0_16231_12830">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </>
          ),
        }
      case 'information':
        return {
          width: 24,
          height: 24,
          icon: (
            <>
              <g clip-path="url(#clip0_16231_12901)">
                <path
                  d="M11.2957 19.2522C11.087 19.2522 10.8783 19.1739 10.7217 19.0435C10.4609 18.8348 10.3304 18.4957 10.4087 18.1565L11.687 11.6348L10.9826 12.0261C10.5391 12.2609 9.9913 12.1304 9.73043 11.687C9.49565 11.2435 9.62609 10.6957 10.0696 10.4348L12.4957 9.05217C12.8087 8.86957 13.2 8.89565 13.487 9.10435C13.7739 9.31304 13.9043 9.67826 13.8522 10.0174L12.5217 16.8L13.6174 16.3304C14.087 16.1217 14.6087 16.3304 14.8174 16.8C15.0261 17.2696 14.8174 17.7913 14.3478 18L11.6609 19.1739C11.5565 19.2261 11.4261 19.2522 11.2957 19.2522ZM13.8783 6.78261C14.113 6.54783 14.2696 6.2087 14.2696 5.86957C14.2696 5.53043 14.1391 5.1913 13.8783 4.95652C13.6435 4.72174 13.3043 4.56522 12.9652 4.56522C12.6261 4.56522 12.287 4.69565 12.0522 4.95652C11.8174 5.1913 11.6609 5.53043 11.6609 5.86957C11.6609 6.2087 11.7913 6.54783 12.0522 6.78261C12.287 7.01739 12.6261 7.17391 12.9652 7.17391C13.3043 7.17391 13.6435 7.04348 13.8783 6.78261ZM24 12C24 5.37391 18.6261 0 12 0C5.37391 0 0 5.37391 0 12C0 18.6261 5.37391 24 12 24C18.6261 24 24 18.6261 24 12ZM21.913 12C21.913 17.4783 17.4783 21.913 12 21.913C6.52174 21.913 2.08696 17.4783 2.08696 12C2.08696 6.52174 6.52174 2.08696 12 2.08696C17.4783 2.08696 21.913 6.52174 21.913 12Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0_16231_12901">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </>
          ),
        }
      case 'clock':
        return {
          width: 92,
          height: 92,
          icon: (
            <>
              <g clip-path="url(#clip0_32_547)">
                <path
                  d="M46 0C20.6 0 0 20.6 0 46C0 71.4 20.6 92 46 92C71.4 92 92 71.4 92 46C92 20.6 71.4 0 46 0ZM46 84C25 84 8 67 8 46C8 25 25 8 46 8C67 8 84 25 84 46C84 67 67 84 46 84ZM61.3 55.6C62.9 57.2 62.9 59.7 61.3 61.3C60.5 62.1 59.5 62.5 58.5 62.5C57.5 62.5 56.5 62.1 55.7 61.3L43.2 48.8C42.4 48.1 42 47.1 42 46V22.2C42 20 43.8 18.2 46 18.2C48.2 18.2 50 20 50 22.2V44.4L61.3 55.6Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0_32_547">
                  <rect width="92" height="92" fill="white" />
                </clipPath>
              </defs>
            </>
          ),
        }
      case 'export':
        return {
          width: 92,
          height: 92,
          icon: (
            <>
              <g clip-path="url(#clip0_32_529)">
                <path
                  d="M73 76.5V81.5C73 83.7 71.1 85 68.9 85H3.6C1.4 85 0 83.8 0 81.5V32.1C0 29.9 1.4 27.9 3.6 27.9H15.3C17.5 27.9 19.3 29.7 19.3 31.9C19.3 34.1 17.5 35.9 15.3 35.9H8V77H65V76.5C65 74.3 66.8 72.5 69 72.5C71.2 72.5 73 74.3 73 76.5ZM90.8 39.2L66 64.5C64.8 65.7 63.1 66 61.6 65.4C60 64.7 59 63.3 59 61.6V50.7C51 50.5 31.8 51.3 24.8 63.6C24.1 64.9 22.7 65.7 21.3 65.7C21 65.7 20.6 65.7 20.3 65.6C18.5 65.1 17.3 63.5 17.3 61.7C17.3 61.1 17.3 45.6 28.9 34.1C36.2 26.6 46 22.6 59 21.9V11C59 9.4 60 7.9 61.5 7.3C63.1 6.7 64.8 7 66 8.2L90.9 33.5C92.4 35.1 92.4 37.6 90.8 39.2ZM82.2 36.3L67 20.9V25.8C67 28 65.3 29.8 63 29.8C50.6 29.8 41.1 33.1 34.6 39.7C31.6 42.7 29.6 46 28.3 49.2C37.7 43.6 49.6 42.6 56.9 42.6C60.7 42.6 63.2 42.9 63.5 42.9C65.5 43.1 67 44.9 67 46.9V51.8L82.2 36.3Z"
                  fill="currentColor"
                />
              </g>
              <defs>
                <clipPath id="clip0_32_529">
                  <rect width="92" height="92" fill="white" />
                </clipPath>
              </defs>
            </>
          ),
        }

      default:
        return { icon: null }
    }
  }

  const { icon, width, height } = selectIcon()

  return (
    <svg
      className={className}
      viewBox={viewBox ? viewBox : `0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      width={size ? size : width}
      height={height}
      style={style}
    >
      {icon}
    </svg>
  )
}
